/*
 * Copyright 2023 Larder Software Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Entity } from '@backstage/catalog-model';
import {
  PROMETHEUS_RULE_ANNOTATION,
  PROMETHEUS_ALERT_ANNOTATION,
  PROMETHEUS_SERVICE_NAME_ANNOTATION,
  PROMETHEUS_ALERT_LABEL_ANNOTATION,
} from './components/util';

export const isPrometheusAvailable = (entity: Entity) =>
  Boolean(entity?.metadata.annotations?.[PROMETHEUS_RULE_ANNOTATION]) ||
  Boolean(entity?.metadata.annotations?.[PROMETHEUS_ALERT_ANNOTATION]) ||
  Boolean(entity?.metadata.annotations?.[PROMETHEUS_SERVICE_NAME_ANNOTATION]) ||
  Boolean(entity?.metadata.annotations?.[PROMETHEUS_ALERT_LABEL_ANNOTATION]);
